Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.getApiMethodType = "GET";
exports.apiKey = "apiKey=0c1bdc31ee2297a78085";
exports.currenciesAPiEndPoint = "https://free.currconv.com/api/v7/currencies?";
exports.currenciesRateAPiEndPoint = "https://free.currconv.com/api/v7/convert?q=FROMCID_TOCID&compact=ultra&";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Cost";
exports.labelTitleText = "Currencty Convertor";
exports.labelBodyText = "Currencty Convertor";
exports.btnExampleTitle = "Convert";
// Customizable Area End